import { Typography } from "antd";
import React from "react";
import styles from "./index.module.scss";

export interface ITMDetailTitleAreaProps {
  // 商标名
  name: string;
  // 商标组合类型
  type: string;
  // 商品编号
  code: string;
}

const TMDetailTitleArea: React.FC<ITMDetailTitleAreaProps> = (props) => {
  return (
    <div className="flex-col">
      <h2 className={styles.title}>{props.name}</h2>
      <div className="flex-row">
        <div className={styles.info}>{`组合类型：${props.type}`}</div>
        <div className={`${styles.info} flex-row`}>商品编号：<Typography.Paragraph
          copyable
          className={styles.info}
          style={{ color: "#999999", marginBottom: 0 }}
        >{props.code}</Typography.Paragraph></div>
        
      </div>
    </div>
  );
};

export default TMDetailTitleArea;
